<a class="cy-skip-link"
   href="#main-content">Skip to main content</a>
<link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons">
<header class="cy-secure-header-host">
    <secure-app-header></secure-app-header>
</header>
<main id="main-content"
      class="secure-main"
      tabindex="-1">
    <router-outlet></router-outlet>
</main>
